import React, { useState } from 'react';
import './FacilityStrip.css';

function FacilityModal({ facility, onClose }) {
  if (!facility) return null;
  return (
    <div className="facility-modal__backdrop" onClick={onClose}>
      <div className="facility-modal" onClick={e => e.stopPropagation()}>
        <button className="facility-modal__close" onClick={onClose}>✕</button>
        <h2 className="facility-modal__title">{facility.title}</h2>
        {facility.description && (
          <p className="facility-modal__desc">{facility.description}</p>
        )}
        {facility.images?.length > 0 && (
          <div className="facility-modal__gallery">
            {facility.images.map(img => (
              <img key={img.id} src={img.image_url} alt={img.caption || facility.title} loading="lazy" />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default function FacilityStrip({ facilities = [] }) {
  const [active, setActive] = useState(null);

  if (!facilities.length) return null;

  return (
    <>
      <div className="facility-strip">
        {facilities.map(f => (
          <button
            key={f.id}
            className="facility-strip__card"
            onClick={() => setActive(f)}
            aria-label={f.title}
          >
            <div className="facility-strip__img">
              {(f.image_url || f.images?.[0]?.image_url) ? (
                <img src={f.image_url || f.images[0].image_url} alt={f.title} loading="lazy" />
              ) : (
                <div className="facility-strip__img-placeholder" />
              )}
            </div>
            <div className="facility-strip__overlay">
              <span className="facility-strip__label">{f.title}</span>
            </div>
          </button>
        ))}
      </div>

      {active && (
        <FacilityModal facility={active} onClose={() => setActive(null)} />
      )}
    </>
  );
}
